import type { BackgroundRoomContext } from '@danda/shared';
import type { LobbyState } from './lobbyStore.types';

export const backgroundSlice: Pick<
  LobbyState,
  | 'backgroundMediaUrl'
  | 'backgroundMediaType'
  | 'backgroundRoomContext'
  | 'isGeneratingBackground'
  | 'backgroundError'
  | 'setBackgroundMedia'
  | 'setGeneratingBackground'
  | 'setBackgroundError'
  | 'characterPortraitUrl'
  | 'characterPortraitType'
  | 'isGeneratingPortrait'
  | 'portraitError'
  | 'setCharacterPortrait'
  | 'setGeneratingPortrait'
  | 'setPortraitError'
> = {
  backgroundMediaUrl: null,
  backgroundMediaType: null,
  backgroundRoomContext: null,
  isGeneratingBackground: false,
  backgroundError: null,

  // Portrait state
  characterPortraitUrl: null,
  characterPortraitType: null,
  isGeneratingPortrait: false,
  portraitError: null,

  setBackgroundMedia: (
    mediaUrl: string | null,
    mediaType: 'video' | 'image' | null,
    roomContext: BackgroundRoomContext | null
  ) => ({
    backgroundMediaUrl: mediaUrl,
    backgroundMediaType: mediaType,
    backgroundRoomContext: roomContext,
    isGeneratingBackground: false,
    backgroundError: null,
  }),

  setGeneratingBackground: (generating: boolean) => ({
    isGeneratingBackground: generating,
    // Only clear error when starting generation, preserve existing error state otherwise
    ...(generating ? { backgroundError: null } : {}),
  }),

  setBackgroundError: (error: string | null) => ({
    backgroundError: error,
    isGeneratingBackground: false,
  }),

  // Portrait actions
  setCharacterPortrait: (portraitUrl: string | null, portraitType: 'image' | 'video' | null) => ({
    characterPortraitUrl: portraitUrl,
    characterPortraitType: portraitType,
    isGeneratingPortrait: false,
    portraitError: null,
  }),

  setGeneratingPortrait: (generating: boolean) => ({
    isGeneratingPortrait: generating,
    ...(generating ? { portraitError: null } : {}),
  }),

  setPortraitError: (error: string | null) => ({
    portraitError: error,
    isGeneratingPortrait: false,
  }),
};
